import { VALIDATION_RULES } from '@/src/data'

type ValidationResult = {
  isValid: boolean
  errorMessage?: string
}

export const validateMainSearchInput = (
  input: string,
  category: string
): ValidationResult => {
  if (!input.trim()) {
    return {
      isValid: true,
      errorMessage: undefined,
    }
  }

  // Common validation for all categories
  if (VALIDATION_RULES.common.disallowedChars.test(input)) {
    return {
      isValid: false,
      errorMessage: VALIDATION_RULES.common.message,
    }
  }

  // Category-specific validation
  switch (category) {
    case 'unified': {
      const rules = VALIDATION_RULES.unified

      // Require minimum length for specialty or condition
      if (input.trim().length < rules.minLength) {
        return {
          isValid: false,
          errorMessage: rules.lengthMessage,
        }
      }

      if (!rules.pattern.test(input)) {
        return {
          isValid: false,
          errorMessage: rules.message,
        }
      }
      break
    }

    case 'full_name': {
      const rules = VALIDATION_RULES.full_name

      // Don't allow numbers for full_name
      const hasNumbers = /\d/.test(input)
      if (hasNumbers) {
        return {
          isValid: false,
          errorMessage: rules.numberMessage,
        }
      }

      if (input.trim().length < rules.minLength) {
        return {
          isValid: false,
          errorMessage: rules.lengthMessage,
        }
      }

      if (!rules.pattern.test(input)) {
        return {
          isValid: false,
          errorMessage: rules.message,
        }
      }
      break
    }

    default:
      return {
        isValid: false,
        errorMessage: 'Invalid search category.',
      }
  }

  return {
    isValid: true,
    errorMessage: undefined,
  }
}
